import { useNavigate } from "react-router"
import { useEffect } from "react"
import { USER_REPORTS_ROUTE } from "../../../constants/routes"

type Props = Readonly<{}>

export function UserHome({}: Props) {
    const navigate = useNavigate()

    useEffect(() => navigate(USER_REPORTS_ROUTE))

    return null
}
